<div class="grid" style="display: flex; min-height: -webkit-fill-available; width: 100vw; overflow-x: hidden" >
  <div class="col-1" style=" width: 10rem; background: #fff">
    <app-sidebar></app-sidebar>
  </div>
  <div  class="col-11  ps-3" style="width: calc(100vw - 10rem);">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
  </div>
</div>
